'use strict';

var basicXhr = function makeXhrFunction(inputOptions) {
	var options = Object.assign({
		method: 'GET',
		success: defaultSuccess,
		parse: defaultParse,
		serialize: defaultSerialize,
		headers: {},
	}, inputOptions);

	return function xhr(url, body) {
		return new Promise(function promise(resolve, reject) {
			var request = new XMLHttpRequest();
			request.addEventListener('load', handleResult);
			request.addEventListener('error', reject);
			request.addEventListener('abort', reject);
			request.open(options.method, url);

			Object.keys(options.headers).forEach(function(key) {
				request.setRequestHeader(key, options.headers[key]);
			});

			if (typeof body === 'undefined') {
				request.send();
			} else {
				request.send(options.serialize(body));
			}

			function handleResult() {
				try {
					var response = options.parse(request);

					options.success(request) ? resolve(response) : reject(response);
				} catch (e) {
					reject(e);
				}
			}
		})
	}
};

function defaultSuccess(request) {
	return request.status >= 200 && request.status < 400
}

function defaultSerialize(body) {
	return JSON.stringify(body)
}

function defaultParse(request) {
	return JSON.parse(request.responseText)
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function basicObjectMap() {
	var obj = Object.create(null);
	return {
		get: function(key) {
			return obj[key]
		},
		set: function(key, value) {
			obj[key] = value;
		},
		has: function(key) {
			return Object.prototype.hasOwnProperty.call(obj, key)
		},
		delete: function(key) {
			delete obj[key];
		},
		object: obj
	}
}

var keyMaster = function(factory, inputMap) {
	var map = inputMap || basicObjectMap();

	function has(key) {
		return map.has(key)
	}

	function get(key) {
		if (!map.has(key) && typeof factory === 'function') {
			map.set(key, factory(key));
		}

		return map.get(key)
	}

	function remove(key) {
		map.delete(key);
	}

	function set(key, value) {
		map.set(key, value);
	}

	function getUnderlyingDataStructure() {
		return inputMap || map.object
	}

	return {
		has: has,
		get: get,
		remove: remove,
		delete: remove,
		unset: remove,
		set: set,
		put: set,
		add: set,
		getUnderlyingDataStructure: getUnderlyingDataStructure,
	}
};

var dynamicImportFactory = createCommonjsModule(function (module) {
	module.exports = function (makeXhr) {
		var getters = {
			json: makeXhr(),
			iife: makeXhr({ parse: parseIife })
		};

		var getterResponses = keyMaster(function (type) {
			return keyMaster(function (path) {
				return getters[type](path);
			});
		});

		return function (path, options) {
			var _Object$assign = Object.assign({ type: 'iife' }, options),
			    type = _Object$assign.type;

			if (!getters[type]) {
				throw new Error('No getter for ' + type);
			}

			return getterResponses.get(type).get(path).catch(function (e) {
				getterResponses.get(type).delete(path);
				throw e;
			});
		};
	};

	var globalEval = eval;
	var iifePrefixRegex = /^\s*(?:var|let|const) ?[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]+ ?= ?/;
	var iifeSuffixRegex = /;(?:\n(?:\/\/.+|\s+)?)*$/;

	function parseIife(response) {
		return globalEval('(' + response.responseText.replace(iifePrefixRegex, '').replace(iifeSuffixRegex, '') + ')');
	}
});

var dynamicImportIife = dynamicImportFactory(basicXhr);

module.exports = dynamicImportIife;
//# sourceMappingURL=dynamic-import-iife.cjs.js.map
